/* jshint esversion: 6, -W097 */
/* globals module */
'use strict';

/**
 * Creates an product card compare button instance
 *
 * @module enervee_utils.product_card
 */
function productCardCompareButtonDirective() {
    return {
        restrict: 'E',
        scope: {
            product: '<',
        },
        bindToController: true,
        controller: productCardCompareButtonController,
        controllerAs: 'vm',
        template: require('./compareButtonView.html')
    };
}

productCardCompareButtonController.$inject = [
    'AnalyticsService',
    'CmsContentService',
    'ProductCompareService'
];
function productCardCompareButtonController(
    AnalyticsService,
    CmsContentService,
    ProductCompareService
) {
    this.$onInit = function () {
        const vm = this;

        vm.inCompareTray = ProductCompareService.isProductInTray(vm.product);
        vm.enableAdd = vm.inCompareTray || ProductCompareService.allowAddProduct();

        /**
         * Callback function to set Compare buttons enable or disable.
         */
        const enableCallback = (enableAdd) => {
            vm.inCompareTray = ProductCompareService.isProductInTray(vm.product);

            if (vm.inCompareTray === false) {
                vm.enableAdd = enableAdd;
            }
        };

        ProductCompareService.enableCallbacks.push(enableCallback);

        /**
         * Add or delete current product to compare tray.
         */
        vm.addOrDeleteToCompareTray = () => {
            let trackingData = {};

            if (vm.inCompareTray === true) {
                ProductCompareService.deleteProductFromTray(vm.product);
                trackingData.type_of_change = 'remove product';
            } else {
                ProductCompareService.addProductToTray(vm.product);
                trackingData.type_of_change = 'add product';
            }

            AnalyticsService.reportEvent('Compare Button Engaged', trackingData, vm.product);
        };
    };
}

module.exports = productCardCompareButtonDirective;
